import React, { Component } from 'react';
import { connect } from 'react-redux';

import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import { GET_HOLISTICS_TOKEN } from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
import { isAdaniWilmar, isDesmetSupplier } from 'Utils/index';
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { reportTypeMapping, screenInfoDetails } from 'Constants/screenInfoDetailsConstants';

class HolisticsMis extends Component {
    state = {
        isLoading: true
    }

    componentDidMount() {
        const { dispatch, match, id } = this.props;
        const user = getUser();
        const companyId = (user && user.companyId) ? user.companyId : '';
        const isSupplier = isDesmetSupplier();

        dispatch({
            type: GET_HOLISTICS_TOKEN,
            params: {
                companyId: companyId,
                type: (match && match.params) ? ((match.params || {}).type) : id,
                branchId: user.branchId,
                ...(isSupplier ? { supplier_id: user.userId } : {})
                // report_id: '1234'
            }
        });
    }
    showReport = () => {
        const { embedCode, token } = this.props;
        return(
            <>
            { this.state.isLoading && <ActionLoader /> }
                {token &&
                    <iframe
                        src={"https://secure.holistics.io/embed/" + embedCode + "?_token=" + token}
                        style={{ width: "100%", height: 600 }}
                        frameBorder="0"
                        title="Transporter Participation"
                        onLoad={() => { this.setState({ isLoading: false }) }}
                        allowFullScreen>
                    </iframe>
                }
            </>
        )
    }


    handleGetScreenInfoDetailsItem = () => {
        const { dispatch, match, id } = this.props;
        const type = (match && match.params) ? ((match.params || {}).type) : id;
        return reportTypeMapping[type] || {}
    }

    render() {
        return (
            <>
                <ScreenTimeTrack
                    screenInfoDetailsItem={
                        this.handleGetScreenInfoDetailsItem()
                    }
                />
            {isAdaniWilmar() ? <> {this.showReport()} </> : 
            <Sticky>{this.showReport()}</Sticky>}
            </>
        );
    }
}

const mapStateToProps = ({constants}) => {
  return {
    token: constants.holistics.token,
    embedCode: constants.holistics.embedCode,
  }
};


export default connect(mapStateToProps)(HolisticsMis);
